import { apiPostRequest } from "helpers/Requests";
import { roleAccess } from "helpers/RolesPermission";
import { USER_ROLE } from "Constants/constant";

export const resolveFormTemplateCloneUrl = (role, routeRole) => {
  if (role === "sil") {
    return "sil/form/clone";
  }
  if (role === "hrm" || routeRole === "hrm") {
    return "sp/hrm/form-templates/clone";
  }
  return "sp/form-templates/clone";
};

export const buildDefaultCloneTitle = (sourceTitle) => {
  const source = sourceTitle?.trim() || "Untitled form";
  return `Copy of ${source}`;
};

export const buildFormTemplateClonePayload = (template) => {
  if (roleAccess([USER_ROLE.Super_Admin])) {
    return { uuid: template.uuid };
  }
  return { form_template_slug: template.slug };
};

export const cloneFormTemplateRequest = async ({
  role,
  routeRole,
  template,
  overrides = {},
}) => {
  const url = resolveFormTemplateCloneUrl(role, routeRole);
  const payload = buildFormTemplateClonePayload(template);
  return apiPostRequest(url, {
    ...payload,
    form_type: "draft",
    ...overrides,
  });
};

export const resolveClonedFormPageHeading = (clonedForm, sourceTitle) => {
  const clonedTitle = clonedForm?.title?.trim();
  if (clonedTitle) {
    return clonedTitle;
  }
  const source = sourceTitle?.trim();
  if (source) {
    return buildDefaultCloneTitle(source);
  }
  return undefined;
};

export const navigateToClonedFormDraft = (
  navigate,
  { role, routeRole, clonedForm, sourceTitle }
) => {
  const slug = clonedForm?.slug;
  if (!slug) {
    return;
  }
  const encode = window.btoa(encodeURIComponent("draft"));
  const pageHeading = resolveClonedFormPageHeading(clonedForm, sourceTitle);
  const navState = { fromClone: true, pageHeading };
  if (role === "sil") {
    navigate(`/sil/edit-template/${slug}/${encode}`, { state: navState });
    return;
  }
  const prefix = routeRole === "hrm" ? "/hrm" : "/crm";
  navigate(`${prefix}/edit-template/${slug}/${encode}`, { state: navState });
};
